import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutValues from './components/AboutValues';
import AboutCTA from './components/AboutCTA';
import SEO, { buildBreadcrumbSchema } from '@/components/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const aboutSchema = [
  buildBreadcrumbSchema([
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
  ]),
  {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: 'About Fore Capital',
  url: `${SITE_URL}/about`,
  description: 'Learn about Fore Capital — our mission, values, and commitment to building transparent, operator-first payment infrastructure for modern merchants.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Fore Capital',
    url: SITE_URL,
    description: 'Custom payment infrastructure for modern merchants.',
    sameAs: [],
  },
  },
];

export default function About() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <SEO
        title="About Fore Capital | Payment Infrastructure Built for Operators"
        description="Learn about Fore Capital — our mission, values, and commitment to building transparent, operator-first payment infrastructure for modern merchants."
        keywords="about Fore Capital, payment infrastructure company, merchant services, fintech company"
        pathname="/about"
        schema={aboutSchema}
      />
      <Navbar />
      <main>
        <AboutHero />
        <AboutStory />
        <AboutValues />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}